module.exports = __webpack_public_path__ + "img/welcome-page-img2.fd02d487.svg";